import {Subject} from 'rxjs';

export class ResourceResultService {
  /**
   * 添加资源 选择器 返回值
   */
  public getSelectResourceSubject = new Subject<any>();
  public getSelectResource = this.getSelectResourceSubject.asObservable();
}
